@let isEditing = agentAssignmentFeatureEc.selectors.isEditing.asSignal();

@if (isEditing) {
  @let selectedUserIds =
    agentAssignmentFeatureEc.selectors.selectedUserIds.asSignal();
  @let selectedAgentIds =
    agentAssignmentFeatureEc.selectors.selectedAgentIds.asSignal();
  @let access = agentAssignmentFeatureEc.selectors.access.asSignal();
  @let accessFlags =
    agentAssignmentFeatureEc.selectors.availableAccessFlags.asSignal();
  @let mutationError =
    agentAssignmentFeatureEc.selectors.mutationErrorMessage.asSignal();

  <atn-ds-centered-overlay>
    <atn-ds-widget title="Agent Assignment">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="closeIconClickHandler()"
      ></i>
      <div class="atn-admin-agent__content">
        <atn-ds-select-multiple
          [config]="{
            overlay: {
              minSearchCharacters: 1,
              hasSearch: true,
            },
          }"
          label="Users"
          [items]="usersSg()"
          [value]="selectedUserIds"
          (valueChange)="selectedUsersChangeHandler($event)"
        />

        <atn-ds-select-multiple
          [config]="{
            overlay: {
              minSearchCharacters: 1,
              hasSearch: true,
            },
          }"
          label="Agents"
          [items]="agentsSg()"
          [value]="selectedAgentIds"
          (valueChange)="selectedAgentsChangeHandler($event)"
        />

        <div class="atn-admin-agent__access">
          <span class="atn-ds-input-field__label">Access</span>
          @for (flag of accessFlags; track flag.value) {
            <div>
              <atn-ds-checkbox
                [label]="flag.label"
                [selected]="isAccessFlagSelected(access, flag.value)"
                (selectedChange)="accessValueChangeHandler($event, flag.value)"
              ></atn-ds-checkbox>
            </div>
          }
        </div>

        @if (hasPageContextSg()) {
          <atn-ds-select-multiple
            label="Page Aliases"
            [items]="appPagesSg()"
            [value]="pageAliasesSg()"
            (valueChange)="pageAliasesChangeHandler($event)"
          />

          <div class="atn-admin-agent__access">
            <atn-ds-checkbox
              label="For Non-Prebuilt Pages"
              [selected]="isForNonPrebuiltPagesSg()"
              (selectedChange)="isForNonPrebuiltPagesChangeHandler($event)"
            ></atn-ds-checkbox>
          </div>
        }
        <atn-admin-error-message [message]="mutationError" />
      </div>
      <div
        class="atn-admin-agent__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelButtonClickHandler()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button (click)="saveClickHandler()">Save</atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
